import Vue from "vue";
import axios from "axios";
import Loacle from "../language/index";
import api from '../api'
import { commonAction } from "@environment/index";
import { getPlatform } from "@/plugins/environment/type.js";

const http = axios.create({
  baseURL: process.env.VUE_APP_BASH_URL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Accept": "application/json",
    "Language": Loacle.requestLanguage,
    "SystemType": getPlatform()
  }
});
http.interceptors.request.use(
  config => {
    let { token } = JSON.parse(localStorage.getItem("auth")) || {};
    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

http.interceptors.response.use(
  (result) => {
    const data = result.data;
    const code = result.data.StatusCode;
    if (code == 401) {
      api.system.tokenRefresh().then((res) => {
        //console.log(res);
        if (res.data && res.data.Token) {
          var auth = JSON.parse(localStorage.getItem("auth"));
          auth.token = res.data.Token;
          localStorage.setItem('auth', JSON.stringify(auth));
          location.reload();
        } else {
          commonAction('routerPush', {
            isParams: false,
            path: "auth/login",
            name: "Login",
            query: [],
          })
        }
      });
      return Promise.resolve(true);
    } else if (data.IsSuccess) {
      return {
        data: data.Content,
        message: data.Message,
        meta: {
          page: data.Content ? data.Content.PageIndexs : null,
          total: data.Content ? data.Content.DataCounts : null,
          lastPage: data.Content ? data.Content.ALLPages : null
        }
      };
    } else {
      const error = { message: data.Message ? data.Message : data.ErrorMsg };
      return Promise.reject(error);
    }
  },
  () => {
    return Promise.reject({ message: Vue.prototype.$t.alert.networkError });
  }
);

export default http;
